module.exports = __webpack_public_path__ + "img/bluebook-2014-main.125c51ce.jpg";